export const dataUrlToFile = (dataUrl, fileName, toBlob) => {
  const arr = dataUrl.split(",");
  const mime = (arr[0].match(/:(.*?);/) || [])[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  if (toBlob) {
    return new Blob([u8arr], {type: mime});
  }
  return new File([u8arr], fileName, {type: mime});
};
export const checkImageWH = (file, width, height, isMaxLimit) => {
  return new Promise((resolve, reject) => {
    const _URL = window.URL || window.webkitURL;
    const img = new Image();
    const doCheck = () => {
      let invalid = false;
      if (isMaxLimit) {
        invalid = img.width > width || img.height > height;
      } else {
        invalid = img.width < width || img.height < height;
      }
      if (invalid) {
        reject(`CheckImageWH Failed`);
      } else {
        resolve(file);
      }
    };
    img.onload = (event) => {
      doCheck();
    };
    img.src = _URL.createObjectURL(file);
    if (img.complete) {
      doCheck();
    }
  });
};
export const checkVideoWH = (file, width, height, isMaxLimit) => {
  return new Promise((resolve, reject) => {
    let video = document.createElement("video");
    video.preload = "metadata";
    video.src = URL.createObjectURL(file);
    const doCheck = () => {
      let invalid = false;
      if (isMaxLimit) {
        invalid = video.width > width || video.height > height;
      } else {
        invalid = video.width < width || video.height < height;
      }
      if (invalid) {
        reject(`CheckImageWH Failed`);
      } else {
        resolve(file);
      }
    };
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      doCheck();
    };
  });
};
export const checkImageRatio = (file, ratio) => {
  return new Promise((resolve, reject) => {
    const _URL = window.URL || window.webkitURL;
    const img = new Image();
    const doCheck = () => {
      const invalid = img.width / img.height !== ratio;
      if (invalid) {
        reject(`CheckImageRatio Failed`);
      } else {
        resolve(file);
      }
    };
    img.onload = (event) => {
      doCheck();
    };
    img.src = _URL.createObjectURL(file);
    if (img.complete) {
      doCheck();
    }
  });
};
export const compress = (file, unCompressSize) => {
  return new Promise((resolve, reject) => {
    let ratio = "1";
    const {size} = file;
    if (!unCompressSize || size > unCompressSize) {
      ratio = Math.pow(1024, 2) / size + "";
      ratio = parseFloat(ratio).toFixed(2);
      resolve(file);
    } else {
      resolve(file);
    }
  });
};
